import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.investment.questions');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-reviewops-investment-questions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.investment.questions/view.scss */
/* src/app/component.reviewops.investment.questions/view.scss: no such file or directory */`],
})
export class ComponentReviewopsInvestmentQuestionsComponent {
    @Input() questions: string[] = [];
}

export default ComponentReviewopsInvestmentQuestionsComponent;